<template>
    <div class="block">
        <!-- <p class="department_p"><el-button round @click="newClick">新增部门</el-button></p>
        <p class="department_p"><span>部门列表</span></p> -->

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>部门列表</b></p>
            <p style="display:inline;float: right;line-height: 22px;margin: 5px 0;">
                <el-button round type="success" @click="newClick">新增部门</el-button>
            </p>
        </div>

        <el-tree :data="departmentTree" show-checkbox node-key="id" default-expand-all :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                    <el-button type="primary" round size="mini" @click="() => editClick(node, data)">
                        编辑
                    </el-button>
                    <el-button type="primary" round size="mini" @click="() => bindRoleClick(node, departmentTree)">
                        绑定角色
                    </el-button>
                    <el-button type="warning" round size="mini" @click="() => removeClick(node, departmentTree)">
                        删除
                    </el-button>
                </span>
            </span>
        </el-tree>

        <el-drawer title="编辑部门" :before-close="handleClose" :visible.sync="departmentDrawer" direction="rtl"
            custom-class="demo-drawer" ref="drawer" style="text-align: left;">

            <div class="demo-drawer__content">

                <el-form :model="form">

                    <el-form-item label="上级部门" :label-width="formLabelWidth">
                        <el-select v-model="form.parentDepartment" placeholder="请选择" @change="selectDepartment"
                            :disabled="parentDeptDisabled">
                            <el-option value="0" label="无上级"></el-option>
                            <el-option v-for="item in departmentList" :key="item.id" :label="item.label" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="部门名称" :label-width="formLabelWidth">
                        <el-input placeholder="请输入" v-model="form.departmentName" autocomplete="off" style="width:300px">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="备注" :label-width="formLabelWidth">
                        <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:300px"></el-input>
                    </el-form-item>

                </el-form>

                <!-- <div class="demo-drawer__footer">
                    <el-button @click="cancelForm">取 消</el-button>
                    <el-button type="primary" @click="$refs.drawer.closeDrawer()" :loading="loading">
                        {{ oading?'提交中...': '确 定' }}
                    </el-button>
                </div> -->

                <div id="cancel_determine">
                    <el-button round @click="cancelForm">取消</el-button>
                    <el-button round type="primary" @click="$refs.drawer.closeDrawer()" :loading="loading">
                        {{ loading ? '提交中...' : '确认' }}
                    </el-button>
                </div>

            </div>
        </el-drawer>

        <el-dialog title="角色绑定" :visible.sync="dialogTableVisible">
            <el-table :data="deptRoleList">
                <el-table-column property="roleName" label="角色名称" width="250"></el-table-column>
                <el-table-column property="roleDescription" label="角色描述" width="250"></el-table-column>

                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small" style="color:#6f5499">
                            {{ scope.row.deptRoleId == null ? '绑定' : '取消绑定' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import globalMethod from "@/method/globalMethod.js";

export default {
    name: "Department",
    mixins: [globalMethod],
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            parentDeptDisabled: false,
            departmentDrawer: false,
            loading: false,
            form: {
                id: '',
                parentId: '0',
                departmentName: '',
                parentDepartment: '',
                remark: ''
            },
            departmentTree: [],
            departmentList: [],
            formLabelWidth: '80px',
            dialogTableVisible: false,
            deptRoleList: []
        }
    },
    methods: {
        handleClose(done) {

            if (this.loading) {
                return;
            } else if (this.form.id == this.form.parentId) {
                this.$message('上级部门不能是自己！！')
                return;
            } else if (this.form.parentId == null) {
                this.form.parentId = '0'
            }

            this.$confirm('确定要提交表单吗？')
                .then(_ => {
                    this.loading = true;
                    this.timer = setTimeout(() => {
                        done();
                        // 动画关闭需要一定的时间
                        setTimeout(() => {
                            this.loading = false;
                            this.form.departmentName = ''
                            this.form.remark = ''
                        }, 400);
                    }, 1000);

                    this.$axios({
                        method: "post",
                        url: "/shiro/department/add",
                        data: {
                            id: this.form.id,
                            parentId: this.form.parentId,
                            label: this.form.departmentName,
                            remark: this.form.remark,
                            companyId: this.companyId
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {
                        //alert(result)
                        if (result.data.status != 200) {
                            this.$message(result.data.msg)
                            return;
                        }
                        this.getDepartmentTree()
                        this.getAllDepartment()
                    })

                })
                .catch(_ => { });
        },
        cancelForm() {
            this.loading = false;
            this.parentDeptDisabled = false
            this.departmentDrawer = false;
            clearTimeout(this.timer);
            this.form.parentDepartment = ''
            this.form.departmentName = ''
            this.form.remark = ''
        },
        getDepartmentTree() {
            this.$axios({
                method: "post",
                url: "/shiro/department/getTree",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data
                
                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.departmentTree = data.data
            })
        },
        selectDepartment(value) {
            // console.log('selectDepartment')
            // console.log(value)
            this.form.parentId = value
        },
        getAllDepartment() {
            this.$axios({
                method: "post",
                url: "/shiro/department/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.departmentList = result.data.data
                //console.log(this.departmentList)
            })
        },
        newClick() {
            this.departmentDrawer = true
            this.form.id = ''
        },
        editClick(node, data) {
            //console.log("data")
            //console.log(data)
            this.parentDeptDisabled = node.data.isParent == 0 ? false : true
            this.departmentDrawer = true

            if (node.data.parentId == '0') {
                this.form.parentDepartment = ''
            } else {
                this.$axios({
                    method: "post",
                    url: "/shiro/department/get",
                    data: {
                        companyId: this.companyId,
                        id: node.data.parentId
                    }, headers: {
                        token: this.token
                    }
                }).then(result => {
                    this.form.parentDepartment = result.data.data.label
                })
            }

            this.form.id = node.data.id
            this.form.departmentName = node.data.label
            this.form.remark = node.data.remark
        },
        bindRoleClick(node, departmentTree) {
            this.dialogTableVisible = true
            this.form.id = node.data.id
            //console.log('dbl')
            //console.log(this.getDeptRole({deptId:this.form.id,companyId: this.$route.query.companyId}, this.token))

            this.deptRoleList = this.getDeptRole({
                deptId: this.form.id,
                companyId: this.companyId
            }, this.token)

        },
        bindDeptRole(row) {
            this.$axios({
                method: "post",
                url: "/shiro/dept/role/add",
                data: {
                    deptId: this.form.id,
                    roleId: row.roleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //alert(result)
                this.deptRoleList = this.getDeptRole({
                    deptId: this.form.id,
                    companyId: this.companyId
                }, this.token)
            })
        },
        unBindDeptRole(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/dept/role/remove",
                data: {
                    id: row.deptRoleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //alert(result)
                this.deptRoleList = this.getDeptRole({
                    deptId: this.form.id,
                    companyId: this.companyId
                }, this.token)
            })
        },
        handleClick(row) {
            if (row.deptRoleId == null) {
                this.bindDeptRole(row)
            } else {
                this.unBindDeptRole(row)
            }
        },
        removeClick(node, departmentTree) {
            if (node.data.isParent == 1) {
                this.$message('当前部门存在子部门，请先删除子部门！！');
                return
            }
            this.$confirm('确定要删除该部门吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeDepartment(node, departmentTree)
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            });
        },
        removeDepartment(node, departmentTree) {

            this.$axios({
                method: "delete",
                url: "/shiro/department/remove",
                data: {
                    companyId: this.companyId,
                    id: node.data.id
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getDepartmentTree()
                this.getAllDepartment()
            })
        }
    },
    mounted() {
        this.getDepartmentTree()
        this.getAllDepartment()
    }
}
</script>

<style>
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

.department_p {
    position: relative;
    right: 5px;
    width: 120px;
    margin: 10px 0px 30px 0px;
}
</style>